export const IOS_WEBVIEW = 'native_ios';
export const ANDROID_WEBVIEW = 'native_android';

export const IOS_MOBILE = 'ios';
export const ANDROID_MOBILE = 'android';
export const IOS_TABLET = 'tablet_ios';
export const ANDROID_TABLET = 'tablet_android';
